var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivateAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 6,
    fill: "url(#paint0_linear_3474_2905)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 31.1216H30.125V39.2466C30.125 39.6776 29.9538 40.0909 29.649 40.3956C29.3443 40.7004 28.931 40.8716 28.5 40.8716C28.069 40.8716 27.6557 40.7004 27.351 40.3956C27.0462 40.0909 26.875 39.6776 26.875 39.2466V31.1216H18.75C18.319 31.1216 17.9057 30.9504 17.601 30.6456C17.2962 30.3409 17.125 29.9276 17.125 29.4966C17.125 29.0656 17.2962 28.6523 17.601 28.3475C17.9057 28.0428 18.319 27.8716 18.75 27.8716H26.875V19.7466C26.875 19.3156 27.0462 18.9023 27.351 18.5975C27.6557 18.2928 28.069 18.1216 28.5 18.1216C28.931 18.1216 29.3443 18.2928 29.649 18.5975C29.9538 18.9023 30.125 19.3156 30.125 19.7466V27.8716H38.25C38.681 27.8716 39.0943 28.0428 39.399 28.3475C39.7038 28.6523 39.875 29.0656 39.875 29.4966C39.875 29.9276 39.7038 30.3409 39.399 30.6456C39.0943 30.9504 38.681 31.1216 38.25 31.1216Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3474_2905",
    x1: 29,
    y1: -19.5907,
    x2: 27.4088,
    y2: 116.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D4D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#0E2D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485802,
    stopColor: "#113C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770259,
    stopColor: "#184C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5850"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateAvatar);
export default __webpack_public_path__ + "static/media/activate-avatar.8d8b9fd1a20677b3c45a2811603cdf01.svg";
export { ForwardRef as ReactComponent };